// extracted by mini-css-extract-plugin
export var locationWrapperStyle = "search_jobs_result_link_location-module--locationWrapperStyle--dhrgx";